import { FunctionComponent, SVGProps } from 'react'

export interface IErrorModalConfig {
  icon: FunctionComponent<SVGProps<SVGSVGElement>>
  title: string
  description: string
}

export enum PaymentErrorsE {
  PURCHASE_LIMIT_EXCEEDED = 'PURCHASE_LIMIT_EXCEEDED',
  PURCHASE_ORDER_IN_PROGRESS = 'PURCHASE_ORDER_IN_PROGRESS',
}

export interface ErrorModalStateT {
  errorType: PaymentErrorsE
}
